import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  active: false,

  // model
  contentsSettingModel: [],

  //form
  serviceId: null,

  value: null,
  
  // データ更新の判別フラグ
  updated: false
}

const getters = {
  get: state => state
}

const actions = {
  show ({commit}, {serviceId}) {
    // cover
    this.dispatch('core/showModalCover')
    console.log('serviceId', serviceId)
    
    commit('setServiceId', serviceId)
    commit('showed')
  },
  hide ({commit}) {
    if (!state.active) return
    commit('hided')
    
    // cover
    setTimeout(() => {
      this.dispatch('core/hideModalCover')
    }, 350)
  },

  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {contentsSettingParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['serviceContentsSetting'],
        ['v1ServiceContentsSettingListGet'],
        [contentsSettingParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setContentsSettingModel', res[0].data.serviceContentsSettings)
            console.log('contentsSettingModel', state.contentsSettingModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * 選択されたファイル情報を保持
   */
  setValue ({commit}, data) {
    commit('setValue', data)
  },

  /**
   * データ更新判別フラグの切替
   */
  setUpdated ({commit}, flag) {
    commit('setUpdated', flag)
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  showed (state) {
    state.active = true
  },
  hided (state) {
    state.active = false
  },

  // model
  setContentsSettingModel (state, data) {
    Vue.set(state, 'contentsSettingModel', data)
  },
  
  // form
  setServiceId (state, id) {
    state.serviceId = id
  },
  setValue (state, data) {
    Vue.set(state, 'value', data)
  },

  // updated
  setUpdated (state, flag) {
    state.updated = flag
  },

  // reset
  reset (state) {
    Vue.set(state, 'fileModel', [])
    Vue.set(state, 'value', null)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
